var map = {
	"./1.png": "0ca1",
	"./2.png": "b9af",
	"./3.png": "c2e4",
	"./4.png": "1105",
	"./5.png": "9310",
	"./6.png": "2175",
	"./7.png": "34bf",
	"./8.png": "f8bf",
	"./bubble.png": "5740",
	"./circle.png": "088b",
	"./times-square.png": "e858",
	"./triangle.png": "d37c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";